import React, { useState, useRef, useEffect } from "react";
import Logo from "../images/logo.svg";
import Sidebar from "../component/Sidebar";
import { SelectPicker, DatePicker, Button, Whisper, Tooltip } from "rsuite";
import "rsuite/SelectPicker/styles/index.css";
import "rsuite/DatePicker/styles/index.css";
import { useParams, useNavigate } from "react-router-dom";
import { ChakraProvider, useToast, Wrap } from "@chakra-ui/react";
import { useLocation } from "react-router-dom";
import moment from "moment-timezone";
import imgBack from "../images/icon-back.svg";

function AddNewCompanyProfile() {
  const timeZone = "Asia/Kolkata";

  const [tabName, setTabName] = useState("IPO Registration");
  const navigate = useNavigate();
  const location = useLocation();
  const id = location.state?.id;
  const buttonLabel = id ? "Update" : "Save";

  const userid = localStorage.getItem("novauserid");
  useEffect(() => {
    document.title = tabName;
  }, [tabName]);

  const apiEndPoint = process.env.REACT_APP_API_ENDPOINT;
  const apiEndPoint1 = process.env.REACT_APP_API_IPO_ENDPOINT;
  const [saveButtonLoader, setSaveButtonLoader] = useState(false);

  const [status, setStatus] = useState("");

  const [companyName, setCompanyName] = useState("");
  const [address, setAddress] = useState("");
  const [city, setCity] = useState("");
  const [state, setState] = useState("");
  const [noOfEmp, setNoOfEmp] = useState("");
  const [phonenumber, setPhonenumber] = useState("");
  const [websiteURL, setWebsiteURL] = useState("");
  const [logo, setLogo] = useState("");
  const summaryRef = useRef(null);

  
  const [is_artificial, setis_artificial] = useState("");
  const [mainTicker, setMainTicker] = useState("");
  const [companySymbol, setCompanySymbol] = useState("");
  const [exchange, setExchange] = useState("");
  const [exchangeCountry, setExchangeCountry] = useState([]);

  const [exchangeSymbol, SetExchangeSymbol] = useState("");
  const [noOfOutstanding, setNoOfOutstanding] = useState("");
  const [currency, setCurrency] = useState([]);

  const [forexRate, setForexRate] = useState("");
  const [marketCapitalization, setMarketCapitalization] = useState("");
  const [mcUSD, setMcUSD] = useState("");
  const [marketClassification, setMarketClassification] = useState("");

  const [countryCode, setCountryCode] = useState("");

  const [mcCurrency, setMcCurrency] = useState("");
  const [ipoDate, setIpoDate] = useState("");
  const [ipoOpenDate, setIpoOpenDate] = useState("");
  const [ipoCloseDate, setIpoCloseDate] = useState("");
  const [isin, setIsin] = useState("");
  const [cusip, setCusip] = useState("");
  const [sedol, setSedol] = useState("");
  const [fromPrice, setFromPrice] = useState("");
  const [toPrice, setToPrice] = useState("");
  const [sharesOffered, setSharesOffered] = useState("");
  const [offersAmount, setOffersAmount] = useState("");

  const [industryClassification, setIndustryClassification] = useState([]);
  const [icValue, setICValue] = useState("");
  const [sector, setSector] = useState([]);
  const [sectorval, setSectorval] = useState("");
  const [industryGroup, setIndustryGroup] = useState("");
  const [industry, setIndustry] = useState("");
  const [subindustry, setSubIndustry] = useState("");
  const [NAICSIndustry, setNAICSIndustry] = useState("");
  const [NAICSNationalIndustry, setNAICSNationalIndustry] = useState("");
  const [NAICSSector, setNAICSSector] = useState("");
  const [NAICSSubSector, setNAICSSubSector] = useState("");


  const handleArtificialChange = (e) => {
  setis_artificial(e.target.checked);
};

  // DATEPICKER
  const [date, setDate] = useState(new Date());

  // handle onChange event of the dropdown
  const handleChange = (value) => {
    setDate(value);
  };

  function CustomCaretIcon() {
    return <i className="icon-calendar"></i>;
  }

  // FILE UPLOAD
  const [fileName, setFileName] = useState("");
  const fileInputRef = useRef(null);

  const handleFileChange = (event) => {
    setFileName(event.target.files[0].name);
  };

  const handleClick = () => {
    fileInputRef.current.click();
  };
  // END FILE UPLOAD

  const data = [
    "India",
    "United State",
    "Australia",
    "Canada",
    "Israel",
    "Germany",
  ].map((item) => ({ label: item, value: item }));

  const [phoneCountryCode, setPhoneCountryCode] = useState("+91");

  const data2 = ["+91", "+92", "+93"].map((item) => ({
    label: item,
    value: item,
  }));

  const marketCapClassification = [
    { label: "Small Cap", value: "SMALL_CAP" },
    { label: "Mid Cap", value: "MID_CAP" },
    { label: "Large Cap", value: "LARGE_CAP" },
    { label: "Mega Cap", value: "MEGA_CAP" },
  ];

  const handleClose = async () => {
    navigate("/ipocompanies");
  };

  const toast = useToast();
  const toastIdRef = React.useRef();

  //   const handleSave = () => {

  //     toastIdRef.current = toast({
  //       description: 'Please Add Company',
  //       status: 'error',
  //       duration: 5000,
  //       isClosable: true,
  //       position: 'bottom-left'
  //     })

  //     toastIdRef.current = toast({
  //         description: 'Please Add Market Cap',
  //         status: 'error', // Set the status to "error" to show an error toast
  //         duration: 5000,  // Duration in milliseconds
  //         isClosable: true,
  //         position: 'bottom-left'
  //       })
  //   }

  const handleCurrencyChange = (value) => {
    setMcCurrency(value);
  };

  useEffect(() => {
    const fetchCurrencyList = async () => {
      const url = `${apiEndPoint}/get_forex_list`;
      const payload = {
        data: {
          user_id: userid, // Replace with the actual user_id if dynamic
        },
      };

      try {
        const response = await fetch(url, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(payload),
        });

        if (!response.ok) {
          throw new Error("Network response was not ok");
        }

        const responseData = await response.json();
        const data = responseData.data; // Flatten the response

        const formatterForexData = data.data.map((forex) => ({
          label: forex.quote_currency,
          value: forex.quote_currency,
        }));

        setCurrency(formatterForexData);
      } catch (error) {
        console.error("get_forex_list API :", error.message);
        toastIdRef.current = toast({
          description: error.message,
          status: "error",
          duration: 5000,
          isClosable: true,
          position: "bottom-left",
        });
        // setErrorMessage(error.message);
        // setMessageType('error');
        return false;
      }
    };

    fetchCurrencyList();
  }, []);

  const handleClassificationChange = (selectedOption) => {
    setMarketClassification(selectedOption);
  };

  const handleIndustryClassificationChange = (selectedOption) => {
    setICValue(selectedOption);
  };

  const handleSectorChange = (selectedOption) => {
    setSectorval(selectedOption);
  };

  //Country List
  useEffect(() => {
    const fetchCountryList = async () => {
      const url = ` ${apiEndPoint}/get_all_country_list`;
      const payload = {
        data: {
          user_id: userid, // Replace with the actual user_id if dynamic
        },
      };

      try {
        const response = await fetch(url, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(payload),
        });

        if (!response.ok) {
          throw new Error("Network response was not ok");
        }

        const responseData = await response.json();
        const data = responseData.data; // Flatten the response

        const formattedCountryData = data.data.map((country) => ({
          label: country.country_name,
          value: country.country_code,
        }));

        setExchangeCountry(formattedCountryData);
      } catch (error) {
        console.log(error);
      }
    };

    fetchCountryList();
  }, []);

  const handleCountryChange = (value) => {
    setCountryCode(value);
  };

  //Finhubb Industry Classification List
  useEffect(() => {
    const fetchCountryList = async () => {
      const url = ` ${apiEndPoint}/get_finnhub_industry_list`;
      const payload = {
        data: {
          user_id: userid, // Replace with the actual user_id if dynamic
        },
      };

      try {
        const response = await fetch(url, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(payload),
        });

        if (!response.ok) {
          throw new Error("Network response was not ok");
        }

        const responseData = await response.json();
        const data = responseData.data; // Flatten the response

        const formattedIndustryData = data.data.map((industry) => ({
          label: industry.industry_name,
          value: industry.industry_name,
        }));

        setIndustryClassification(formattedIndustryData);
      } catch (error) {
        console.log(error);
      }
    };

    fetchCountryList();
  }, []);

  //Sector List
  useEffect(() => {
    const fetchCountryList = async () => {
      const url = ` ${apiEndPoint}/get_sector_list`;
      const payload = {
        data: {
          user_id: userid, // Replace with the actual user_id if dynamic
        },
      };

      try {
        const response = await fetch(url, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(payload),
        });

        if (!response.ok) {
          throw new Error("Network response was not ok");
        }

        const responseData = await response.json();
        const data = responseData.data; // Flatten the response

        const formattedSectorData = data.data.map((sector) => ({
          label: sector.sector_name,
          value: sector.sector_name,
        }));

        setSector(formattedSectorData);
      } catch (error) {
        console.log(error);
      }
    };

    fetchCountryList();
  }, []);
  const handleSave = async () => {
    // Create a flag to check if there are any errors
    let hasError = false;

    // Check if the companyName field is empty
    if (!companyName) {
      toastIdRef.current = toast({
        description: "Please Add Company Name",
        status: "error",
        duration: 5000,
        isClosable: true,
        position: "bottom-left",
      });
      hasError = true;
    }
    if (!address) {
      toastIdRef.current = toast({
        description: "Please Add Address",
        status: "error",
        duration: 5000,
        isClosable: true,
        position: "bottom-left",
      });
      hasError = true;
    }
    if (!summaryRef.current.value) {
      toastIdRef.current = toast({
        description: "Please Add Company Description",
        status: "error",
        duration: 5000,
        isClosable: true,
        position: "bottom-left",
      });
      hasError = true;
    }

    // Check if the mainTicker field is empty
    if (!mainTicker) {
      toastIdRef.current = toast({
        description: "Please Add Main Ticker",
        status: "error",
        duration: 5000,
        isClosable: true,
        position: "bottom-left",
      });
      hasError = true;
    }
    if (!companySymbol) {
      toastIdRef.current = toast({
        description: "Please Add Company Symbol",
        status: "error",
        duration: 5000,
        isClosable: true,
        position: "bottom-left",
      });
      hasError = true;
    }

    if (!exchange) {
      toastIdRef.current = toast({
        description: "Please Add Exchange",
        status: "error",
        duration: 5000,
        isClosable: true,
        position: "bottom-left",
      });
      hasError = true;
    }
    if (!countryCode) {
      toastIdRef.current = toast({
        description: "Please Select Exchange Country",
        status: "error",
        duration: 5000,
        isClosable: true,
        position: "bottom-left",
      });
      hasError = true;
    }

    // Check if the currency field is empty
    if (!mcCurrency) {
      toastIdRef.current = toast({
        description: "Please Select Currency",
        status: "error",
        duration: 5000,
        isClosable: true,
        position: "bottom-left",
      });
      hasError = true;
    }

    if (countryCode === "IN") {
      if (!ipoOpenDate) {
        toastIdRef.current = toast({
          description: "Please Select Issue Opening Date",
          status: "error",
          duration: 5000,
          isClosable: true,
          position: "bottom-left",
        });
        hasError = true;
      }

      if (!ipoCloseDate) {
        toastIdRef.current = toast({
          description: "Please Select Issue Closing Date",
          status: "error",
          duration: 5000,
          isClosable: true,
          position: "bottom-left",
        });
        hasError = true;
      }
    } else {
      if (!ipoDate) {
        toastIdRef.current = toast({
          description: "Please Select IPO Date",
          status: "error",
          duration: 5000,
          isClosable: true,
          position: "bottom-left",
        });
        hasError = true;
      }
    }

    // If there are no errors, proceed with the save logic
    if (!hasError) {
      setSaveButtonLoader(true);

      const companyData = {
        data: {
          ...(id && { id: id }),
          // user_id: userid,
          name: companyName,
          address: address,
          city: city,
          state: state,
          employee: noOfEmp,
          phone: phonenumber,
          website: websiteURL,
          logo: logo,
          company_summary: summaryRef.current.value,
          main_ticker: mainTicker,
          symbol: companySymbol,
          exchange: exchange,
          exchange_country: countryCode,
          currency: mcCurrency,
          date: moment(ipoDate).tz(timeZone).format(),
          MarketCapitalization: marketCapitalization,
          shareoutstanding: noOfOutstanding,
          isin: isin,
          cusip: cusip,
          sedol: sedol,
          price_from: fromPrice,
          price_to: toPrice,
          numberOfShares: sharesOffered,
          totalSharesValue: offersAmount,
          industry_Classification: icValue,
          sector: sectorval,
          industry_group: industryGroup,
          industry: industry,
          subindustry: subindustry,
          naics_industry: NAICSIndustry,
          naics_national_industry: NAICSNationalIndustry,
          naics_sector: NAICSSector,
          naics_subsector: NAICSSubSector,
          status: status,
          ipo_open_date: moment(ipoOpenDate).tz(timeZone).format(),
          ipo_close_date: moment(ipoCloseDate).tz(timeZone).format(),
          is_artificial:is_artificial,
        },
      };
      console.log(JSON.stringify(companyData));

      try {
        const response = await fetch(`${apiEndPoint1}/add_update_ipo`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(companyData),
        });

        const result = await response.json();

        if (response.ok) {
          // Check if the response contains an error status
          if (result.data.status === "success") {
            setSaveButtonLoader(false);
            toastIdRef.current = toast({
              description: result.data.message,
              status: "success",
              duration: 5000,
              isClosable: true,
              position: "bottom-left",
            });
            setTimeout(() => navigate("/ipocompanies"), 4000);
          } else if (result.data.status === "error") {
            setSaveButtonLoader(false);
            toastIdRef.current = toast({
              description: result.data.message,
              status: "error",
              duration: 5000,
              isClosable: true,
              position: "bottom-left",
            });
            return false;
          }
        } else {
          setSaveButtonLoader(false);
          toastIdRef.current = toast({
            description: "An error occurred while adding the company profile",
            status: "error",
            duration: 5000,
            isClosable: true,
            position: "bottom-left",
          });
          return false;
        }
      } catch (error) {
        setSaveButtonLoader(false);
        toastIdRef.current = toast({
          description: error.message,
          status: "error",
          duration: 5000,
          isClosable: true,
          position: "bottom-left",
        });
        return false;
      }
    }
  };

  // Function to fetch company details
  const fetchCompanyDetails = async () => {
    const url = `${apiEndPoint1}/get_ipo`;
    const data = {
      data: {
        user_id: userid, // Replace with actual user ID
        id: id, // Replace with actual company ID
        company_symbol: "", // Optional: leave it blank or provide a symbol
      },
    };

    try {
      const response = await fetch(url, {
        method: "POST", // Use 'POST' since you're sending data
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data), // Convert JavaScript object to JSON
      });

      // Check if the response is successful
      if (!response.ok) {
        throw new Error("Network response was not ok");
      }

      // Parse the response body as JSON
      const result = await response.json();

      // Check if the 'status' field in the response is success
      if (result.data.status === "success") {
        //setCompanyDetails(result.data.company_details);

        setStatus(result.data.data.status);

        setCompanyName(result.data.data.name);
        setAddress(result.data.data.address);
        setCity(result.data.data.city);
        setState(result.data.data.state);
        setNoOfEmp(result.data.data.employee);
        setPhonenumber(result.data.data.phone);
        setWebsiteURL(result.data.data.website);
        setLogo(result.data.data.logo);
        summaryRef.current.value = result.data.data.company_summary;

        setis_artificial(result.data.data.is_artificial);
        setMainTicker(result.data.data.main_ticker);
        setCompanySymbol(result.data.data.symbol);
        setExchange(result.data.data.exchange);
        setCountryCode(result.data.data.exchange_country);
        setMcCurrency(result.data.data.currency);
        const ipoDate = moment(result.data.data.ipo_date)
          .tz(timeZone)
          .format("YYYY-MM-DD");
        setIpoDate(new Date(result.data.data.ipo_date));

        setIpoOpenDate(new Date(result.data.data.ipo_open_date));
        setIpoCloseDate(new Date(result.data.data.ipo_close_date));

        setMarketCapitalization(result.data.data.MarketCapitalization);
        setNoOfOutstanding(result.data.data.shareoutstanding);
        setIsin(result.data.data.isin);
        setCusip(result.data.data.cusip);
        setSedol(result.data.data.sedol);
        setFromPrice(result.data.data.price_from);
        setToPrice(result.data.data.price_to);
        setSharesOffered(result.data.data.numberOfShares);
        setOffersAmount(result.data.data.totalSharesValue);

        setICValue(result.data.data.industry_Classification);
        setSectorval(result.data.data.sector);
        setIndustryGroup(result.data.data.industry_group);
        setIndustry(result.data.data.industry);
        setSubIndustry(result.data.data.subindustry);
        setNAICSIndustry(result.data.data.naics_industry);
        setNAICSNationalIndustry(result.data.data.naics_national_industry);
        setNAICSSector(result.data.data.naics_sector);
        setNAICSSubSector(result.data.data.naics_subsector);
      } else {
        // If the status is not success, set the error
        //setError(result.data.message);
      }
    } catch (error) {
      console.error("Error fetching company details:", error);
      //setError('Error fetching company details');
    } finally {
      // Set loading to false after fetch attempt
      //setLoading(false);
    }
  };

  // useEffect to call fetchCompanyDetails on component mount
  useEffect(() => {
    if (id) {
      // Only call fetchCompanyDetails if `id` is truthy (not undefined or null)
      fetchCompanyDetails();
    }
  }, [id]);

  //   const close = () => {
  //     if (toastIdRef.current) {
  //       toast.close(toastIdRef.current)
  //     }
  //   }

  const handleBack = async () => {
    navigate("/ipocompanies");
  };

  return (
    <>
      <Sidebar />

      {/* <ChakraProvider>
      <Wrap>
        <Button onClick={addToast}>Toast</Button>
      </Wrap>
    </ChakraProvider> */}

      <div id="header">
        <div className="logo">
          <Button className="btn_Back_head" onClick={handleBack}>
            <img src={imgBack} />
          </Button>
          <div className="logo_icon">
            <img src={Logo} />
          </div>
          <div className="brand_name">Add Pre-IPO Company Profile</div>
        </div>

        <div className="">
          <ul className="add_company_btn_list">
            <div className="select_ipo_status">
              <label>IPO Status</label>
              <Button className="btn__expected">{status || "Upcoming"}</Button>
            </div>
          </ul>
        </div>
      </div>

      <div className="container-fluid content pb-4">
        <div className="company_details_form">
          <h2>Company Details</h2>

          <div className="form_details_group mt-3">
            <div className="row">
              <div className="col-sm-6 col-lg-4">
                <label className="label_form">
                  Company Name<span className="star_red">*</span>
                </label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Company"
                  value={companyName}
                  onChange={(e) => setCompanyName(e.target.value)}
                />
              </div>

              <div className="col-sm-6 col-lg-4">
                <label className="label_form">
                  Address<span className="star_red">*</span>
                </label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Address"
                  value={address}
                  onChange={(e) => setAddress(e.target.value)}
                />
              </div>

              <div className="col-sm-6 col-lg-2">
                <label className="label_form">City</label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="City"
                  value={city}
                  onChange={(e) => setCity(e.target.value)}
                />
              </div>

              <div className="col-sm-6 col-lg-2">
                <label className="label_form">State</label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="State"
                  value={state}
                  onChange={(e) => setState(e.target.value)}
                />
              </div>
            </div>
          </div>

          <div className="form_details_group mt-3">
            <div className="row">
              <div className="col-sm-6 col-lg-3">
                <label className="label_form">No. of Employees</label>
                <input
                  onKeyDown={(e) => {
                    if (
                      e.key === "e" ||
                      e.key === "E" ||
                      e.key === "+" ||
                      e.key === "-"
                    ) {
                      e.preventDefault();
                    }
                  }}
                  type="number"
                  className="form-control"
                  placeholder="Total Employee"
                  value={noOfEmp}
                  onChange={(e) => setNoOfEmp(e.target.value)}
                />
              </div>

              <div className="col-sm-6 col-lg-3">
                <label className="label_form">Phone No.</label>
                {/* <div className="input-group">
                                    <input onKeyDown={(e) => { if (e.key === 'e' || e.key === 'E' || e.key === '+' || e.key === '-') { e.preventDefault(); } }} type="number" className="form-control" placeholder="Phone" value={phonenumber} onChange={(e) => setPhonenumber(e.target.value)} />
                                </div> */}

                <div className="input-group">
                  <input
                    onKeyDown={(e) => {
                      if (
                        e.key === "e" ||
                        e.key === "E" ||
                        e.key === "+" ||
                        e.key === "-"
                      ) {
                        e.preventDefault();
                      }
                    }}
                    type="number"
                    className="form-control"
                    placeholder="Phone"
                    value={phonenumber}
                    onChange={(e) => setPhonenumber(e.target.value)}
                  />
                </div>
              </div>

              <div className="col-sm-6 col-lg-3">
                <label className="label_form">Website URL</label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Web URL"
                  value={websiteURL}
                  onChange={(e) => setWebsiteURL(e.target.value)}
                />
              </div>

              <div className="col-sm-6 col-lg-3">
                <label className="label_form">Logo URL</label>
                <div className="input-group file_input_group">
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Logo URL"
                    value={logo}
                    onChange={(e) => setLogo(e.target.value)}
                  />
                </div>
              </div>
            </div>
          </div>

          <div className="form_details_group mt-3">
            <div className="row">
              <div className="col-sm-12">
                <label className="label_form">
                  Company Description<span className="star_red">*</span>
                </label>
                <textarea
                  rows={2}
                  className="form-control"
                  ref={summaryRef}
                ></textarea>
              </div>
            </div>
          </div>

          <div className="mt-4">
            <h2>IPO details</h2>

            <div className="form_details_group mt-3">
              <div className="row">
                <div className="col-sm-12 mb-3"></div>

                <div className="col-sm-6 col-lg-2">
                  <div className="form-check clsArtificialTicker">
                    <Whisper
                      placement="auto"
                      controlId="control-id-hover"
                      trigger="hover"
                      speaker={<Tooltip>Check this box if this is an Artificial Ticker</Tooltip>}
                    >
                      <input className="form-check-input" type="checkbox" id={`checkbox`}  checked={is_artificial} onChange={handleArtificialChange}/>
                    </Whisper>
                    <label className="label_form" htmlFor={`checkbox`}> Main Ticker<span className="star_red">*</span> </label>
                  </div>

                  <input
                    type="text"
                    className="form-control"
                    placeholder="Main Ticker"
                    value={mainTicker}
                    onChange={(e) => setMainTicker(e.target.value)}
                  />
                </div>

                <div className="col-sm-6 col-lg-2">
                  <label className="label_form">
                    Company Symbol<span className="star_red">*</span>
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Ticker"
                    value={companySymbol}
                    onChange={(e) => setCompanySymbol(e.target.value)}
                  />
                </div>
                <div className="col-sm-6 col-lg-2">
                  <label className="label_form">
                    Listed Exchange<span className="star_red">*</span>
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Listed exchange"
                    value={exchange}
                    onChange={(e) => setExchange(e.target.value)}
                  />
                </div>

                <div className="col-sm-6 col-lg-2 ">
                  <label className="label_form">
                    Exchange Country<span className="star_red">*</span>
                  </label>
                  <div className="form_select_drop">
                    <SelectPicker
                      data={exchangeCountry}
                      searchable={true}
                      style={{ width: "100%" }}
                      placeholder="Exchange Country"
                      onChange={handleCountryChange}
                      value={countryCode}
                    />
                  </div>
                </div>

                <div className="col-sm-6 col-lg-2">
                  <label className="label_form">
                    Currency<span className="star_red">*</span>
                  </label>
                  <div className="form_select_drop">
                    <SelectPicker
                      data={currency}
                      //searchable={true}
                      // style={{ width: '100%'  }}
                      menuClassName="fxCurrencyComapnyProfile"
                      placeholder=""
                      onChange={handleCurrencyChange}
                      value={mcCurrency}
                      cleanable={true}
                    />
                  </div>
                </div>

                {countryCode === "IN" ? (
                  <>
                    <div className="row mt-3">
                      <div className="col-sm-6 col-lg-2">
                        <label className="label_form">
                          Issue Opening Date<span className="star_red">*</span>
                        </label>
                        <div className="form_datepicker">
                          <DatePicker
                            oneTap
                            style={{ width: "100%" }}
                            placement="auto"
                            placeholder="DD/MM/YYYY"
                            caretAs={CustomCaretIcon}
                            value={ipoOpenDate}
                            onChange={(date) => setIpoOpenDate(date)}
                          />
                        </div>
                      </div>

                      <div className="col-sm-6 col-lg-2">
                        <label className="label_form">
                          Issue Closing Date<span className="star_red">*</span>
                        </label>
                        <div className="form_datepicker">
                          <DatePicker
                            oneTap
                            style={{ width: "100%" }}
                            placement="auto"
                            placeholder="DD/MM/YYYY"
                            caretAs={CustomCaretIcon}
                            value={ipoCloseDate}
                            onChange={(date) => setIpoCloseDate(date)}
                          />
                        </div>
                      </div>
                    </div>
                  </>
                ) : (
                  <div className="col-sm-6 col-lg-2">
                    <label className="label_form">
                      IPO Date<span className="star_red">*</span>
                    </label>
                    <div className="form_datepicker">
                      <DatePicker
                        oneTap
                        style={{ width: "100%" }}
                        placement="auto"
                        placeholder="DD/MM/YYYY"
                        caretAs={CustomCaretIcon}
                        value={ipoDate}
                        onChange={(date) => setIpoDate(date)}
                      />
                    </div>
                  </div>
                )}
              </div>
            </div>

            <div className="form_details_group mt-3">
              <div className="custom_row">
                <div className="custom_col5">
                  <label className="label_form">
                    Market Capitalization(Once)
                  </label>
                  <input
                    onKeyDown={(e) => {
                      if (
                        e.key === "e" ||
                        e.key === "E" ||
                        e.key === "E" ||
                        e.key === "+" ||
                        e.key === "-"
                      ) {
                        e.preventDefault();
                      }
                    }}
                    type="number"
                    className="form-control"
                    placeholder="Market Capitalization"
                    value={marketCapitalization}
                    onChange={(e) => setMarketCapitalization(e.target.value)}
                  />
                </div>

                <div className="custom_col5">
                  <label className="label_form">
                    No. of Outstanding Shares
                  </label>
                  <input
                    onKeyDown={(e) => {
                      if (
                        e.key === "e" ||
                        e.key === "E" ||
                        e.key === "+" ||
                        e.key === "-"
                      ) {
                        e.preventDefault();
                      }
                    }}
                    type="number"
                    className="form-control"
                    placeholder="Outstanding Number"
                    value={noOfOutstanding}
                    onChange={(e) => setNoOfOutstanding(e.target.value)}
                  />
                </div>

                <div className="custom_col5">
                  <label className="label_form">ISIN No.</label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="ISIN No."
                    value={isin}
                    onChange={(e) => setIsin(e.target.value)}
                  />
                </div>

                <div className="custom_col5">
                  <label className="label_form">CUSIP No.</label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="CUSIP No."
                    value={cusip}
                    onChange={(e) => setCusip(e.target.value)}
                  />
                </div>
                <div className="custom_col5">
                  <label className="label_form">Sedol No.</label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Sedol No."
                    value={sedol}
                    onChange={(e) => setSedol(e.target.value)}
                  />
                </div>
              </div>
            </div>

            <div className="form_details_group mt-3">
              <div className="row">
                <div className="col-sm-6 col-lg-4">
                  <label className="label_form">Price Range</label>
                  <div className="range__row">
                    <div class="range__col">
                      <input
                        type="number"
                        className="form-control"
                        placeholder="From"
                        value={fromPrice}
                        onChange={(e) => setFromPrice(e.target.value)}
                      />
                    </div>
                    <span>to</span>
                    <div class="range__col">
                      <input
                        type="number"
                        className="form-control"
                        placeholder="To"
                        value={toPrice}
                        onChange={(e) => setToPrice(e.target.value)}
                      />
                    </div>
                  </div>
                </div>

                <div className="col-sm-6 col-lg-4">
                  <label className="label_form">Shares Offered</label>
                  <input
                    type="number"
                    className="form-control"
                    placeholder="Shares Offered"
                    value={sharesOffered}
                    onChange={(e) => setSharesOffered(e.target.value)}
                  />
                </div>

                <div className="col-sm-6 col-lg-4">
                  <label className="label_form">Offers Amount</label>
                  <input
                    type="number"
                    className="form-control"
                    placeholder="Offers Amount"
                    value={offersAmount}
                    onChange={(e) => setOffersAmount(e.target.value)}
                  />
                </div>
              </div>
            </div>
          </div>

          <div className="mt-4">
            <h2>Compliance Section</h2>

            <div className="form_details_group mt-3">
              <div className="custom_row">
                <div className="custom_col5">
                  <label className="label_form">
                    Finnhub Industry Classification
                  </label>
                  <div className="form_select_drop">
                    <SelectPicker
                      data={industryClassification}
                      searchable={false}
                      placeholder="Select Classification"
                      style={{ width: "100%" }}
                      onChange={handleIndustryClassificationChange} // Attach onChange event handler
                      value={icValue}
                    />
                  </div>
                </div>

                <div className="custom_col5">
                  <label className="label_form">Sector</label>
                  {/* <input type="text" className="form-control" placeholder="Sector" value={sector} onChange={(e) => setSector(e.target.value)} /> */}
                  <div className="form_select_drop">
                    <SelectPicker
                      data={sector}
                      searchable={false}
                      placeholder="Select Classification"
                      style={{ width: "100%" }}
                      onChange={handleSectorChange} // Attach onChange event handler
                      value={sectorval}
                    />
                  </div>
                </div>

                <div className="custom_col5">
                  <label className="label_form">Industry Group</label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Industry Group"
                    value={industryGroup}
                    onChange={(e) => setIndustryGroup(e.target.value)}
                  />
                </div>

                <div className="custom_col5">
                  <label className="label_form">Industry</label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Industry"
                    value={industry}
                    onChange={(e) => setIndustry(e.target.value)}
                  />
                </div>

                <div className="custom_col5">
                  <label className="label_form">Sub-Industry</label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Sub-Industry"
                    value={subindustry}
                    onChange={(e) => setSubIndustry(e.target.value)}
                  />
                </div>
              </div>
            </div>

            <div className="form_details_group mt-3">
              <div className="row">
                <div className="col-sm-6 col-lg-3">
                  <label className="label_form">NAICS Industry</label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="NAICS Industry"
                    value={NAICSIndustry}
                    onChange={(e) => setNAICSIndustry(e.target.value)}
                  />
                </div>

                <div className="col-sm-6 col-lg-3">
                  <label className="label_form">NAICS National Industry</label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="NAICS national industry"
                    value={NAICSNationalIndustry}
                    onChange={(e) => setNAICSNationalIndustry(e.target.value)}
                  />
                </div>

                <div className="col-sm-6 col-lg-3">
                  <label className="label_form">NAICS Sector</label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="NAICS Sector"
                    value={NAICSSector}
                    onChange={(e) => setNAICSSector(e.target.value)}
                  />
                </div>

                <div className="col-sm-6 col-lg-3">
                  <label className="label_form">NAICS Sub-Sector</label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="NAICS Sub-Sector"
                    value={NAICSSubSector}
                    onChange={(e) => setNAICSSubSector(e.target.value)}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="add_new_btn_group">
        <button className="btn_cancel_form" onClick={handleClose}>
          Cancel
        </button>
        <ChakraProvider>
          <Wrap>
            {/* <Button onClick={addToast}>Toast</Button> */}
            <Button
              className="btn_save_form"
              onClick={handleSave}
              loading={saveButtonLoader}
            >
              {buttonLabel}
            </Button>
          </Wrap>
        </ChakraProvider>
      </div>
    </>
  );
}

export default AddNewCompanyProfile;
